export const PROFITABLE_VS_UNPROFITABLE_IPO_FILTER_VALUE_MIN = 0.001;
export const PROFITABLE_VS_UNPROFITABLE_IPO_FILTER_VALUE_MAX = 0;
